import COUNTRIES_JSON from '@/assets/countries.json'
import dashboardTourImg1 from '@/assets/v2/images/dashboardTour1.svg'
import dashboardTourImg2 from '@/assets/v2/images/dashboardTour2.svg'
import dashboardTourImg3 from '@/assets/v2/images/dashboardTour3.svg'
import dashboardTourImg4 from '@/assets/v2/images/dashboardTour4.svg'
import dashboardTourImg5 from '@/assets/v2/images/dashboardTour5.svg'
import dashboardTourImg6 from '@/assets/v2/images/dashboardTour6.svg'
import torusDashboardImg1 from '@/assets/v2/images/torusDashboard1.svg'
import torusDashboardImg2 from '@/assets/v2/images/torusDashboard2.svg'
import torusDashboardImg3 from '@/assets/v2/images/torusDashboard3.svg'
import torusDashboardImg4 from '@/assets/v2/images/torusDashboard4.svg'
import torusDashboardImg5 from '@/assets/v2/images/torusDashboard5.svg'
import {
  SWAP_ASSETS_NETWORKS,
  BARE_ASSETS,
  WALLET_VALIDATOR_PACKAGE
} from '@/utils/swapassets.js'
import COLLECT_BANKS_JSON from '@/assets/collect_banks.json'
import NSANO_BANKS_JSON from '@/assets/nsano_banks.json'
import US_STATES_JSON from '@/assets/usStates.json'

export const HAS_REFRESHED = 'has_refreshed'
export const USER_TOKEN = 'user_token'
export const USER_TOKEN_EXPIRY_TIME = 'user_token_expiry_time'
export const ADMIN_EMAIL = 'admin_email'
export const ADMIN_TENANT = 'tenant'
export const ADMIN_BUSINESS_ID = 'admin_business_id'
export const ADMIN_BUSINESS_NAME = 'admin_business_name'

export const USER_NAME = 'user_name'
export const USER_EMAIL = 'user_email'
export const USER_PHONE = 'user_phone'
export const USER_BUSINESS_TYPE = 'user_business_type'
export const USER_WEBSITE = 'user_website'

export const TEST_URl = 'test_base_url'
export const COUNTRY_LIST = [
  { value: 'NG', label: 'Nigeria' },
  { value: 'US', label: 'USA' },
  { value: 'IN', label: 'India' }
]
export const ALL_COUNTRIES = COUNTRIES_JSON
export const ALL_NIGERIAN_BANKS = COLLECT_BANKS_JSON
export const NSANO_BANKS = NSANO_BANKS_JSON
export const US_STATES = US_STATES_JSON
export const TRANSFER_TYPE = [
  { label: 'Local Currency', value: 'Local Currency' }
]
export const TRANSFER_LOCATIONS = [
  {
    label: 'Wire transfer (United States Only)',
    value: 'Within The United States',
    disabled: false
  },
  {
    label: 'Wire transfer (International)',
    value: 'International Transfer',
    disabled: false
  },
  {
    label: 'Direct Debit (Powered by Plaid ACH)',
    value: 'Plaid',
    disabled: process.env.NODE_ENV === 'production' // Temporary for deployment
  }
]
export const LOCAL_COUNTRIES = [
  {
    name: 'nigeria',
    symbol: '₦',
    currency: 'NGN',
    currencyFull: 'Nigerian Naira',
    shortCode: 'NG'
  },
  {
    name: 'ghana',
    symbol: '₵',
    currency: 'GHS',
    currencyFull: 'Ghanaian Cedis',
    shortCode: 'GH'
  },
  {
    name: 'central-cfa-franc',
    symbol: '₣',
    currency: 'XAF',
    currencyFull: 'Central African CFA franc',
    shortCode: 'XAF'
  },
  {
    name: 'west-cfa-franc',
    symbol: 'CFA',
    currency: 'XOF',
    currencyFull: 'West African CFA franc',
    shortCode: 'XOF',
    currencyCountriesFull: ['senegal', 'ivory-coast'],
    currencyCountriesShortCode: ['SN', 'CI']
  }
]
export const DEFAULT_TRANSFER_DETAILS = {
  exchange_rate: 0,
  fees_percentage: 0
}
export const STABLE_COINS = [
  {
    name: 'usdc-ethereum',
    symbol: '$',
    currency: 'USDC',
    network: 'Ethereum',
    currencyFull: 'USDC - Ethereum',
    shortCode: 'USDC'
  },
  {
    name: 'usdt-ethereum',
    symbol: '$',
    currency: 'USDT',
    network: 'Ethereum',
    currencyFull: 'USDT - Ethereum',
    shortCode: 'USDT'
  }
]
export const NON_NGN_LOCAL_CURRENCIES = ['XAF', 'XOF', 'GHS']
export const GLOBAL_FIAT_CURRENCIES = [
  {
    name: 'usa',
    symbol: '$',
    currency: 'USD',
    currencyFull: 'US Dollars',
    shortCode: 'US'
  },
  {
    name: 'uk',
    symbol: '£',
    currency: 'GBP',
    currencyFull: 'Pound sterling',
    shortCode: 'UK'
  },
  {
    name: 'euro',
    symbol: '€',
    currency: 'EUR',
    currencyFull: 'Euro',
    shortCode: 'EU'
  }
]
export const GLOBAL_NON_USD_FIAT_CURRENCIES = [
  {
    name: 'uk',
    symbol: '£',
    currency: 'GBP',
    currencyFull: 'Pound sterling',
    shortCode: 'UK'
  },
  {
    name: 'euro',
    symbol: '€',
    currency: 'EUR',
    currencyFull: 'Euro',
    shortCode: 'EU'
  }
]
export const ASSETS = [...STABLE_COINS]
export const FIAT = [...GLOBAL_FIAT_CURRENCIES, ...LOCAL_COUNTRIES]

export const COUNTRIES = [...FIAT, ...ASSETS]
export const OMNI_SUPPORTED_CURRENCIES = [
  {
    name: 'nigeria',
    symbol: '₦',
    currency: 'NGN',
    currencyFull: 'Nigerian Naira',
    shortCode: 'NG'
  },
  {
    name: 'usa',
    symbol: '$',
    currency: 'USD',
    currencyFull: 'US Dollars',
    shortCode: 'US'
  },
  {
    name: 'uk',
    symbol: '£',
    currency: 'GBP',
    currencyFull: 'Pound sterling',
    shortCode: 'UK'
  },
  {
    name: 'euro',
    symbol: '€',
    currency: 'EUR',
    currencyFull: 'Euro',
    shortCode: 'EU'
  },
  {
    name: 'usdc-ethereum',
    symbol: '$',
    currency: 'USDC',
    network: 'Ethereum',
    currencyFull: 'USDC - Ethereum',
    shortCode: 'USDC'
  },
  {
    name: 'usdt-ethereum',
    symbol: '$',
    currency: 'USDT',
    network: 'Ethereum',
    currencyFull: 'USDT - Ethereum',
    shortCode: 'USDT'
  }
]
export const IFT_OMNI_SUPPORTED_CURRENCIES = [
  {
    name: 'ghana',
    symbol: '₵',
    currency: 'GHS',
    currencyFull: 'Ghanaian Cedis',
    shortCode: 'GH'
  }
]
export const CURRENCY = [{ value: 'USD', label: 'USD' }]
export const ASSET_TYPE = [{ value: 'USDC', label: 'USDC' }]
export const USDC_NETWORKS = [
  {
    label: 'Ethereum (ERC-20)',
    value: 'ETH',
    shortName: 'ETH',
    validator: WALLET_VALIDATOR_PACKAGE
  }
]
export const ASSETS_NETWORKS = [
  {
    label: 'Ethereum (ERC-20)',
    value: 'ETH',
    shortName: 'ETH',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    label: 'Binance Smart Chain (BSC)',
    value: 'BSC',
    shortName: 'BSC',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    label: 'Cardano (ADA)',
    value: 'ADA',
    shortName: 'ADA',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    label: 'Solana (SOL)',
    value: 'SOL',
    shortName: 'SOL',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    label: 'Ripple (XRP)',
    value: 'XRP',
    shortName: 'XRP',
    validator: WALLET_VALIDATOR_PACKAGE
  },
  {
    label: 'Stellar (XLM)',
    value: 'XLM',
    shortName: 'XLM',
    validator: WALLET_VALIDATOR_PACKAGE
  },

  {
    label: 'Tron (TRX)',
    value: 'TRX',
    shortName: 'TRX',
    validator: WALLET_VALIDATOR_PACKAGE
  }
]
export const USER_ROLE = [
  { value: 2, label: 'Accountant' },
  { value: 3, label: 'Deposit only' },
  { value: 4, label: 'Withdrawal only' },
  { value: 5, label: 'View only' }
]
export const TORUS_USER_ROLE = [
  { value: 2, label: 'Accountant' },
  { value: 5, label: 'View only' }
]
export const ROLES = [
  {
    label: 'owner',
    value: 1,
    title: 'Full Dashboard Access',
    subTitle: 'Owner',
    body: 'The Owner has full access to the dashboard which include to initiate and approve Transfers, make deposits , Swaps, and Withdrawals.',
    subBody: 'This user has full access to the dashboard',
    access: 'You have full access to the dashboard.'
  },
  {
    label: 'admin',
    value: 2,
    title: 'Full Dashboard Access',
    subTitle: 'Admin',
    body: 'The Admin has full access to the dashboard which include to initiate and approve Transfers, make deposits , Swaps, and Withdrawals.',
    subBody: 'This user has full access to the dashboard',
    access: 'You have full access to the dashboard.'
  },
  {
    label: 'initiate_and_approve_only',
    value: 3,
    title: 'Initiate and Approve Only',
    body: 'This user can  approve and initiate withdrawals, transfers and swaps.',
    access:
      'You have access to  approve and initiate withdrawals, transfers and swaps.'
  },
  {
    label: 'initiate_only',
    value: 4,
    title: 'Initiate Only',
    body: 'This user can initiate transfers, swaps, and make deposits.',
    access: 'You have access to initiate transfers, swaps, and make deposits.'
  },
  {
    label: 'approve_only',
    value: 5,
    title: 'Approve Only',
    body: 'This user can approve withdrawal, transfers and swaps.',
    access: 'You have access to approve withdrawal, transfers and swaps.'
  },
  {
    label: 'developer_access',
    value: 6,
    title: 'Developer Access',
    body: 'This user has view only access, and can access API keys only.',
    access: 'You have view only access, and can access API keys only.'
  },
  {
    label: 'view_only',
    value: 7,
    title: 'View Only Access',
    body: 'This user has read only access to this dashboard ',
    access: 'You have read only access to this dashboard '
  }
]
export const STATUS = {
  PENDING: 'pending',
  APPROVE: 'approve',
  APPROVED: 'approved',
  PROCESSING: 'processing',
  REJECTED: 'rejected',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FLAGGED: 'flagged',
  NEEDS_ATTENTION: 'needs_attention',
  HISTORY: 'history',
  CANCEL: 'cancel',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  IN_DISPUTE: 'in_dispute',
  PENDING_REVIEW: 'pending_review',
  FROZEN: 'frozen',
  ACTIVE: 'active',
  NEEDS_UPDATE: 'needs_update',
  INACTIVE: 'inactive',
  INITIATED: 'initiated',
  VERIFYING: 'verifying',
  ONGOING: 'ongoing',
  UNAPPROVED: 'unapproved',
  SUBMITTED: 'submitted',
  REFUNDED: 'refunded',
  DEACTIVATED: 'deactivated',
  FALLBACK: 'fallback',
  AWAITING_APPROVAL: 'awaiting_approval',
  AWAITING_BUSINESS_APPROVAL: 'awaiting_business_approval',
  DISAPPROVE: 'disapprove',
  DISAPPROVED: 'disapproved',
  TERMINATED: 'terminated',
  RETURNED: 'returned'
  // Add more statuses as needed
}
export const COUNTRY_SHORTNAMES = {
  NG: 'NG',
  US: 'US',
  IN: 'IN',
  GH: 'GH',
  CM: 'CM',
  CI: 'CI',
  SN: 'SN',
  BJ: 'BJ'
  // kindly add more countries as required
}
export const PROVIDER = { ZEEPAY: 'zeepay' }
export const BUSINESS_TYPES = [
  { value: 'fintech', label: 'Fintech' },
  { value: 'sme', label: 'SME (Small & Medium Enterprises)' },
  { value: 'hni', label: 'HNI (High Networth Individual)' }
]
export const COUNTRY_CODE_OPTIONS = [
  { value: 'NG', label: 'NG +234', name: 'nigeria', currency: 'NGN' },
  { value: 'US', label: 'US +1', name: 'usa', currency: 'USD' },
  { value: 'IN', label: 'IN +91', name: 'india' },
  { value: 'GH', label: 'GH +233', name: 'ghana', currency: 'GHS' },

  // XAF COUNTRIES
  { value: 'CM', label: 'CM +237', name: 'cameroon', currency: 'XAF' },
  { value: 'ML', label: 'ML +223', name: 'mali', currency: 'XAF' },
  { value: 'NE', label: 'NE +227', name: 'niger', currency: 'XAF' },
  { value: 'BF', label: 'BF +226', name: 'burkina-faso', currency: 'XAF' },
  { value: 'GQ', label: 'GQ +240', name: 'equatorial-guinea', currency: 'XAF' },
  { value: 'GW', label: 'GW +245', name: 'guinea-bissau', currency: 'XAF' },
  { value: 'CI', label: 'CI +225', name: "cote-d'ivoire", currency: 'XAF' },
  { value: 'SN', label: 'SN +221', name: 'senegal', currency: 'XAF' },

  // XOF COUNTRIES
  { value: 'BJ', label: 'BJ +229', name: 'benin', currency: 'XOF' },

  // GBP COUNTRIES
  { value: 'UK', label: 'UK +44', name: 'united-kingdom', currency: 'GBP' },
  { value: 'JE', label: 'JE +44', name: 'jersey', currency: 'GBP' },
  { value: 'GG', label: 'GG +44', name: 'guernsey', currency: 'GBP' },
  { value: 'IM', label: 'IM +44', name: 'isle-of-man', currency: 'GBP' },

  // EUR COUNTRIES
  { value: 'AT', label: 'AT +43', name: 'austria', currency: 'EUR' },
  { value: 'BE', label: 'BE +32', name: 'belgium', currency: 'EUR' },
  { value: 'CY', label: 'CY +357', name: 'cyprus', currency: 'EUR' },
  { value: 'EE', label: 'EE +372', name: 'estonia', currency: 'EUR' },
  { value: 'FI', label: 'FI +358', name: 'finland', currency: 'EUR' },
  { value: 'FR', label: 'FR +33', name: 'france', currency: 'EUR' },
  { value: 'DE', label: 'DE +49', name: 'germany', currency: 'EUR' },
  { value: 'GR', label: 'GR +30', name: 'greece', currency: 'EUR' },
  { value: 'IE', label: 'IE +353', name: 'ireland', currency: 'EUR' },
  { value: 'IT', label: 'IT +39', name: 'italy', currency: 'EUR' },
  { value: 'LV', label: 'LV +371', name: 'latvia', currency: 'EUR' },
  { value: 'LT', label: 'LT +370', name: 'lithuania', currency: 'EUR' },
  { value: 'LU', label: 'LU +352', name: 'luxembourg', currency: 'EUR' },
  { value: 'MT', label: 'MT +356', name: 'malta', currency: 'EUR' },
  { value: 'NL', label: 'NL +31', name: 'netherlands', currency: 'EUR' },
  { value: 'PT', label: 'PT +351', name: 'portugal', currency: 'EUR' },
  { value: 'SK', label: 'SK +421', name: 'slovakia', currency: 'EUR' },
  { value: 'SI', label: 'SI +386', name: 'slovenia', currency: 'EUR' },
  { value: 'ES', label: 'ES +34', name: 'spain', currency: 'EUR' }
]
export const WITHDRAWAL_ACCESS = [1, 2, 3, 4]
export const DEPOSIT_ACCESS = [1, 2, 3, 4, 5]
export const APPROVER_WITH_TRANSACTION_LIMIT = [
  'initiate_and_approve_only',
  'approve_only'
]
export const APPROVER_ACCESS = [
  'owner',
  'admin',
  'initiate_and_approve_only',
  'approve_only'
]
export const INITIATOR_ACCESS = [
  'owner',
  'admin',
  'initiate_and_approve_only',
  'initiate_only'
]
export const API_SECRET_TIP_INFO =
  'This secret would be utilized in generating your public & static bearer keys for encryption & decryption of messages via API. If you feel your keys have been compromised, simply input a new secret and regenerate keys'
export const GENDER_TYPES = [
  {
    label: 'Male',
    value: 'male'
  },
  {
    label: 'Female',
    value: 'female'
  }
]
export const TITLE_TYPES = [
  {
    label: 'Mr.',
    value: 'Mr'
  },
  {
    label: 'Mrs.',
    value: 'Mrs'
  },
  {
    label: 'Ms.',
    value: 'Ms'
  },
  {
    label: 'Miss',
    value: 'Miss'
  },
  {
    label: 'Dr.',
    value: 'Dr'
  },
  {
    label: 'Prof.',
    value: 'Prof'
  },
  {
    label: 'Rev.',
    value: 'Rev'
  },
  {
    label: 'Sir',
    value: 'Sir'
  },
  {
    label: 'Lady',
    value: 'Lady'
  },
  {
    label: 'Mx.',
    value: 'Mx'
  },
  {
    label: 'Master',
    value: 'Master'
  },
  {
    label: 'Dame',
    value: 'Dame'
  },
  {
    label: 'Capt.',
    value: 'Capt'
  },
  {
    label: 'Col.',
    value: 'Col'
  },
  {
    label: 'Maj.',
    value: 'Maj'
  },
  {
    label: 'Lt.',
    value: 'Lt'
  },
  {
    label: 'Hon.',
    value: 'Hon'
  },
  {
    label: 'Sgt.',
    value: 'Sgt'
  }
]

export const ROUTES_WITHOUT_KYC_ACCESS = [
  'login',
  'signUp',
  'forgotPassword',
  'recoverPassword',
  'setUpKyc',
  'dashboard',
  'signUpInvite',
  'accountSetup'
]
export const COMPANY_TYPES = [
  {
    label: 'Public Limited Company (PLC)',
    value: 'public limited company'
  },
  {
    label: 'Limited Company (LTD)',
    value: 'limited company'
  },
  {
    label: 'Sole Proprietorship',
    value: 'sole proprietorship'
  },
  {
    label: 'Others',
    value: 'others'
  }
]
export const URL_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?[\w.-]+\.[a-zA-Z]{2,20}(?:\/[\w.-]*)*\/?$/
export const TEST_URL_REGEX =
  /^(https?:\/\/)?((localhost)|((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|([\w-]+\.?)+(\.\w{2,20}))(:\d{1,5})?(\/\S*)?$/

export const PHONE_NUMBER_REGEX = /^\d{9,15}$/
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.,#/-])[A-Za-z\d@$!%*?&.,#/-]{8,}$/
export const VALID_ID_TYPES = [
  {
    label: "Driver's License",
    value: 'drivers_license'
  },
  {
    label: 'International Passport',
    value: 'international_passport'
  },
  {
    label: "Voter's Card",
    value: 'voters_card'
  },
  {
    label: 'National Identification Number',
    value: 'national_id'
  }
]

// swap pairs
export const swapAssetsNetworks = SWAP_ASSETS_NETWORKS
export const bareAssets = BARE_ASSETS
export const DATE_RANGES = [
  {
    label: 'From Newest',
    value: 'from newest'
  },
  {
    label: 'From Oldest',
    value: 'from oldest'
  },
  {
    label: '7 Days',
    value: 7
  },
  {
    label: '30 Days',
    value: 30
  }
]

export const TRANSACTION_OPTIONS = [
  {
    name: 'Holding Transactions',
    value: 'deposit'
  },
  {
    name: 'Transfers',
    value: 'transfer'
  },
  {
    name: 'Bridge Swaps',
    value: 'swap'
  }
]
export const TWO_FA_KEYS_ALLOWED = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9'
]
export const PAYOUT_TYPES = [
  {
    label: 'Recurring Payout',
    value: 'recurring_payout'
  },
  {
    label: 'One Time Payout',
    value: 'one_time'
  }
]
export const RECURRING_PERIODS = [
  {
    label: 'Daily',
    value: 'daily'
  },
  {
    label: 'Weekly',
    value: 'weekly'
  },
  {
    label: 'Monthly',
    value: 'monthly'
  }
]
export const WEEKLY_RECURRING_PERIODS = [
  {
    label: 'Monday',
    value: 'monday'
  },
  {
    label: 'Tuesday',
    value: 'tuesday'
  },
  {
    label: 'Wednesday',
    value: 'wednesday'
  },
  {
    label: 'Thursday',
    value: 'thursday'
  },
  {
    label: 'Friday',
    value: 'friday'
  },
  {
    label: 'Saturday',
    value: 'saturday'
  },
  {
    label: 'Sunday',
    value: 'sunday'
  }
]
export const BENEFICIARY_TYPES = [
  {
    label: 'Single Beneficiary',
    value: 'single'
  },
  {
    label: 'Multiple Beneficiaries',
    value: 'multiple'
  }
]
export const OVAL_TOUR_IMAGES = [
  { imagePath: dashboardTourImg1 },
  { imagePath: dashboardTourImg2 },
  { imagePath: dashboardTourImg3 },
  { imagePath: dashboardTourImg4 },
  { imagePath: dashboardTourImg5 },
  { imagePath: dashboardTourImg6 }
]
export const TORUS_TOUR_IMAGES = [
  { imagePath: torusDashboardImg1 },
  { imagePath: torusDashboardImg2 },
  { imagePath: torusDashboardImg3 },
  { imagePath: torusDashboardImg4 },
  { imagePath: torusDashboardImg5 }
]
export const TMA_TOUR_IMAGES = [
  { imagePath: torusDashboardImg1 },
  { imagePath: torusDashboardImg2 },
  { imagePath: torusDashboardImg3 }
]
// APP TOUR
export const DASHBOARD_TOUR = {
  name: 'dashboardTour',
  steps: [
    {
      target: '#dashboardTourItem1', // this holds the id of the element currently being explained upon
      params: { placement: 'top', enableScrolling: false }, // You can control the position of the tour popup here.
      title: 'Fund Account',
      desc: 'Initiate deposits quickly to fund your accounts.',
      route: '/'
    },
    {
      target: '#dashboardTourItem2',
      params: { placement: 'right' },
      title: 'FX Transfer',
      desc: 'Send money to friends, family, or business associates seamlessly around the world.',
      route: 'terminal'
    },
    {
      target: '#dashboardTourItem3',
      params: { placement: 'right' },
      title: 'Payout',
      desc: 'Create payouts for faster and more efficient payments.',
      route: 'payout'
    },
    {
      target: '#dashboardTourItem4', // this holds the id of the element currently being explained upon
      params: { placement: 'right' },
      title: 'Payment Link',
      desc: 'Generate payment links to receive and make payments conveniently.',
      route: 'receive-payment'
    },
    {
      target: '#dashboardTourItem5',
      params: { placement: 'right' },
      title: 'Manage Cards',
      desc: 'Manage cards directly from the dashboard. Activate, deactivate, and monitor card transactions in one place.',
      route: 'cards'
    },
    {
      target: '#dashboardTourItem6',
      params: { placement: 'right' },
      title: 'Bridge',
      desc: 'Carry out swaps to exchange Cryptocurrency  with ease for better rate.',
      route: 'bridge'
    }
  ]
}
export const TRANSACTIONS_TOUR = {
  name: 'transactionsTour',
  steps: [
    {
      target: '#transactionsTourItem1',
      params: { placement: 'top', enableScrolling: false },
      desc: 'You can view all your transaction history and see details of all your transactions.'
    },
    {
      target: '#transactionsTourItem2',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Start by funding your account to get started with transactions.'
    }
  ]
}
export const SEND_MONEY_TOUR = {
  name: 'sendMoneyTour',
  steps: [
    {
      target: '#sendMoneyTourItem1',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Enter the amount you want to send'
    },
    {
      target: '#sendMoneyTourItem2',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Select the currency you want to send.'
    },
    {
      target: '#sendMoneyTourItem3',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Select the currency the recipient will receive and see their expected amount.'
    },
    {
      target: '#sendMoneyTourItem4',
      params: { placement: 'bottom' },
      offset: -500,
      desc: 'Click on Continue then proceed to enter recipient details and make the Payment.'
    }
  ]
}

export const EXCHANGE_RATE_TOUR = {
  name: 'exchangeRateTour',
  steps: [
    {
      target: '#exchangeRateTourItem1',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Choose your source currency.'
    },
    {
      target: '#exchangeRateTourItem2',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Select the destination currency to see the exchange rate.'
    },
    {
      target: '#exchangeRateTourItem3',
      params: { placement: 'top', enableScrolling: false },
      desc: 'Explore the rate section and search as needed.'
    }
  ]
}
export const BRIDGE_TOUR = {
  name: 'bridgeTour',
  steps: [
    {
      target: '#bridgeTourItem1',
      params: { placement: 'top' },
      desc: 'Enter the amount and select the Asset and Network you want to send.'
    },
    {
      target: '#bridgeTourItem2',
      params: { placement: 'top' },
      desc: 'Select the Asset and Network the recipient will receive and see their expected amount.'
    },
    {
      target: '#bridgeTourItem3',
      params: { placement: 'top' },
      desc: 'Provide beneficiary address details and once your wallet is reviewed, you can start using it for Swaps.'
    }
  ]
}

export const CARDS_TOUR = {
  name: 'cardsTour',
  steps: [
    {
      target: '#cardsTourItem1',
      params: { placement: 'top', enableScrolling: false },
      desc: 'Choose your card type (virtual or physical).'
    },
    {
      target: '#cardsTourItem2',
      params: { placement: 'top', enableScrolling: false },
      desc: 'Fill in your card details and billing address, including proof of address.'
    },
    {
      target: '#cardsTourItem3',
      params: { placement: 'bottom' },
      desc: 'See total card fees and confirm.'
    }
  ]
}
export const PAYMENT_METHODS = [
  {
    label: 'Bank Transfer',
    value: 'banks'
  },
  {
    label: 'Mobile Money',
    value: 'mno'
  }
]
export const BULKPAYOUT_DOCUMENT_TEMPLATE_TYPE = [
  {
    label: 'Banks',
    value: 'banks'
  },
  {
    label: 'Mobile Money',
    value: 'mno'
  }
]

// For Currencies that support both mobile wallets and bank transfer
export const ENABLED_MULTI_CURRENCY_AND_METHODS = [
  {
    currency: 'GHS',
    isMobileMoneyEnabled: true,
    isBankTransferEnabled: true
  },
  {
    currency: 'XAF',
    isMobileMoneyEnabled: true,
    isBankTransferEnabled: false
  },
  {
    currency: 'XOF',
    isMobileMoneyEnabled: true,
    isBankTransferEnabled: true
  }
]

export const GHS_PAYOUT_METHODS = [
  {
    label: 'Bank Transfer',
    value: 'bank_transfer'
  },
  {
    label: 'Mobile Money',
    value: 'mobile_money'
  }
]
export const GHS_MONEY_PROVIDER = [
  {
    fullName: 'VODAFONE CASH',
    shortName: 'VODAFONE'
  },
  {
    fullName: 'MTN MOBILE MONEY',
    shortName: 'MTN'
  },
  {
    fullName: 'AIRTELTIGO MONEY',
    shortName: 'AIRTELTIGO'
  }
  // {
  //   fullName: 'ORANGES MONEY',
  //   shortName: 'ORANGESL'
  // },
  // {
  //   fullName: 'AFRIMONEY',
  //   shortName: 'AFRICEL'
  // },
  // {
  //   fullName: 'ORANGE MONEY',
  //   shortName: 'ORANGECI'
  // },
]
export const FRANC_MONEY_PROVIDERS = [
  {
    fullName: 'MTN',
    shortName: 'MTN'
  },
  {
    fullName: 'ORANGE',
    shortName: 'ORANGE'
  }
]
export const XOF_MONEY_PROVIDERS = [
  ...FRANC_MONEY_PROVIDERS,
  {
    fullName: "ORANGE MONEY COTE D'IVOIRE",
    shortName: 'OM-C1'
  },
  {
    fullName: 'ORANGE MONEY SENEGAL',
    shortName: 'OM-S2'
  }
]
export const XAF_MONEY_PROVIDERS = [
  ...FRANC_MONEY_PROVIDERS,
  {
    fullName: 'ORANGE MONEY CAMEROUN',
    shortName: 'CAM002'
  }
]
export const BULK_PAYOUT_TOUR = {
  name: 'bulkPayout',
  steps: [
    {
      target: '#bulkPayoutTourItem1',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Click on New Payout to create a Payout'
    },
    {
      target: '#bulkPayoutTourItem2',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Choose your payout currency, and the amount will be deducted from your holding currency balance'
    },
    {
      target: '#bulkPayoutTourItem3',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Select Beneficiary type'
    },
    {
      target: '#bulkPayoutTourItem4',
      params: { placement: 'bottom' },
      desc: 'Enter  a descriptive payout name to identify the transaction.'
    },
    {
      target: '#bulkPayoutTourItem5',
      params: { placement: 'bottom' },
      desc: 'Select the Payout Frequency, proceed to  review the details, and confirm the payout.'
    }
  ]
}
export const PAYMENT_LINKS_TOUR = {
  name: 'paymentLinksTour',
  steps: [
    {
      target: '#paymentLinkItem1',
      params: { placement: 'bottom' },
      desc: 'Click "New Payment Link" to start.'
    },
    {
      target: '#paymentLinkItem2',
      params: { placement: 'bottom' },
      desc: 'Enter the title, description, select currency, and enter amount to Receive.'
    },
    {
      target: '#paymentLinkItem3',
      params: { placement: 'top' },
      desc: 'Configure settings: charge fees, collect address, phone number, or make it a one-time payment.'
    },
    {
      target: '#paymentLinkItem4',
      params: { placement: 'top' },
      desc: 'Set up the confirmation, display a message or redirect to a website.'
    },
    {
      target: '#paymentLinkItem5',
      params: { placement: 'top' },
      desc: 'Finalize the process by clicking "Create Link.'
    }
  ]
}
export const SETTINGS_TOUR = {
  name: 'SettingsTour',
  steps: [
    {
      target: '#settingsTourItem1',
      params: { placement: 'top', enableScrolling: false },
      desc: 'Update your business details, Enhance security by changing your password.',
      route: '/settings/business-overview'
    },
    {
      target: '#settingsTourItem2',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'Manage API keys, including generating them and configuring webhook URLs.',
      route: '/settings/api-keys'
    },
    {
      target: '#settingsTourItem3',
      params: { placement: 'bottom', enableScrolling: false },
      desc: 'User management, add users, assign roles via email, and manage user accounts.',
      route: '/settings/user-management'
    }
    // {
    //   target: '#settingsTourItem4',
    //   params: { placement: 'bottom' },
    //   desc: 'Add and  Manage Beneficiaries for Assets and Fiat.',
    //  route: '/settings/beneficiaries'
    // }
  ]
}
export const FUND_ACCT_TOUR = {
  name: 'fundAcctTour',
  steps: [
    {
      target: '#fundAcctTourItem1',
      params: { placement: 'top' },
      desc: 'Read through the deposit agreement and click on “I Agree”'
    },
    {
      target: '#fundAcctTourItem2',
      params: { placement: 'top' },
      desc: 'Choose your destination currency, enter the deposit amount, select your deposit option, and review the details.'
    },
    {
      target: '#fundAcctTourItem3',
      params: { placement: 'top' },
      desc: 'Your deposit will be labeled as "pending" until Oval receives the funds, and once successful, it will be confirmed.'
    }
  ]
}
export const IS_RECURRING_PAYOUT_RETRY_STATUS = ['failed', 'skipped']

export const KYC_INFO = [
  {
    step: 1,
    title: 'Business Information',
    content:
      'Business profile, entity address, entity contact and declaration of sources',
    icon: 'business-icon',
    totalItems: 4
  },
  {
    step: 2,
    title: 'Directors and Ultimate Beneficial Owner Information',
    content:
      'Basic information, identification details, biometric verification and country of residence of related parties',
    icon: 'add-user-icon',
    totalItems: 2
  },
  {
    step: 3,
    title: 'Upload Document',
    content: 'Provide the required documents to verify your entity',
    icon: 'upload-icon',
    totalItems: 12
  }
]

export const HNI_KYC_INFO = [
  {
    step: 1,
    title: 'Basic Information',
    content: 'User profile and user address',
    icon: 'user-icon',
    totalItems: 2
  },
  {
    step: 2,
    title: 'Additional Information',
    content: 'Biometric verification and next of kin information',
    icon: 'add-user-icon',
    totalItems: 2
  },
  {
    step: 3,
    title: 'Upload Document',
    content: 'Provide the required documents to verify your entity',
    icon: 'upload-icon',
    totalItems: 4
  }
]

export const BUSINESS_INFO = [
  {
    step: 1,
    title: 'Business Information',
    component: 'business-profile',
    show: false
  },
  {
    step: 2,
    title: 'Transaction Profile',
    component: 'transaction-profile',
    show: false
  },
  {
    step: 3,
    title: 'Entity Address',
    component: 'entity-address',
    show: false
  },
  {
    step: 4,
    title: 'Contact Person Information',
    component: 'contact-information',
    show: false
  }
]

export const HNI_BUSINESS_INFO = [
  {
    step: 1,
    title: 'User Information',
    component: 'user-profile',
    show: false
  },
  {
    step: 2,
    title: 'Address Information',
    component: 'user-address',
    show: false
  }
]

export const DIRECTORS_INFO = [
  {
    step: 5,
    title: 'Directors and Ultimate Beneficiary Owner Information',
    component: 'director-profile',
    show: false,
    type: 'director'
  },
  {
    step: 5.5,
    title: 'Entities',
    component: 'director-profile',
    show: false,
    type: 'entity'
  },
  {
    step: 6,
    title: 'Biometric Verification',
    component: 'biometric',
    show: false
  }
]

export const HNI_DIRECTORS_INFO = [
  {
    step: 3,
    title: 'Biometric Verification',
    component: 'biometric',
    show: false
  },
  {
    step: 4,
    title: 'Next Of Kin',
    component: 'next-of-kin',
    show: false
  }
]

export const UPLOAD_INFO = [
  {
    step: 1,
    title: 'Certificate of Incorporation',
    component: 'incorporation',
    document: 'certificate_of_incorporation',
    show: false,
    isCompulsory: true
  },
  {
    step: 2,
    title: 'Regulatory License of Operation',
    component: 'regulatory-licence',
    document: 'regulatory_license_of_operation',
    show: false,
    isCompulsory: false
  },
  {
    step: 3,
    title: 'Certified Copy of Memorandum and Article of Association ',
    component: 'memorandum',
    document: 'certified_copy_of_memorandum',
    show: false,
    isCompulsory: true
  },
  {
    step: 4,
    title: 'Proof of Business Address',
    component: 'proof-of-address',
    document: 'proof_of_business_address',
    show: false,
    isCompulsory: true
  },
  {
    step: 5,
    title:
      'Certified Copy of Shareholding Structure ( Name and Percentage for Each Individual/ Entity That is Part of the Structure)',
    component: 'shareholding-structure',
    document: 'certificate_copy_of_shareholding',
    show: false,
    isCompulsory: true
  },
  {
    step: 6,
    title:
      'Latest Audited Financial Statement Or Three (3) Months Business Bank Statement',
    component: 'financial-statement',
    document: 'unaudited_financial_statement',
    show: false,
    isCompulsory: true
  },
  {
    step: 7,
    title: 'Business Source of Funds',
    component: 'source-of-funds',
    document: 'business_source_of_funds',
    show: false,
    isCompulsory: true
  },
  {
    step: 8,
    title: 'Tax Identification Number (TIN)',
    component: 'tax-identification',
    document: 'tax_identification_number',
    show: false,
    isCompulsory: true
  },
  {
    step: 9,
    title:
      'Anti - Money Laundering / Combating the Financing of Terrorism Policy (AML/CFT/CPF Policy)',
    component: 'anti-money-laundering',
    document: 'anti_money_laundering',
    show: false,
    isCompulsory: true
  },
  {
    step: 10,
    title: 'List of Directors',
    component: 'list-of-directors',
    document: 'list_of_directors',
    show: false,
    isCompulsory: false
  },
  {
    step: 11,
    title: 'Wolfsberg Questionnaire',
    component: 'wolfsberg-questionnaire',
    document: 'completed_wolfsperg_questionnaire',
    show: false,
    isCompulsory: true
  },
  {
    step: 12,
    title: 'Attestation',
    component: 'attestation',
    document: 'attestation',
    show: false,
    isCompulsory: true
  }
]

export const SME_UPLOAD_INFO = [
  {
    step: 1,
    title: 'Certificate of Incorporation',
    component: 'incorporation',
    document: 'certificate_of_incorporation',
    show: false,
    isCompulsory: true
  },
  {
    step: 2,
    title: 'Regulatory License of Operation',
    component: 'regulatory-licence',
    document: 'regulatory_license_of_operation',
    show: false,
    isCompulsory: false
  },
  {
    step: 3,
    title: 'Certified Copy of Memorandum',
    component: 'memorandum',
    document: 'certified_copy_of_memorandum',
    show: false,
    isCompulsory: true
  },
  {
    step: 4,
    title: 'Proof of Business Address',
    component: 'proof-of-address',
    document: 'proof_of_business_address',
    show: false,
    isCompulsory: true
  },
  {
    step: 5,
    title:
      'Certified Copy of Shareholding Structure ( Name and Percentage for Each Individual/ Entity That is Part of the Structure)',
    component: 'shareholding-structure',
    document: 'certificate_copy_of_shareholding',
    show: false,
    isCompulsory: true
  },
  {
    step: 6,
    title:
      'Latest Audited Financial Statement Or Three (3) Months Business Bank Statement',
    component: 'financial-statement',
    document: 'unaudited_financial_statement',
    show: false,
    isCompulsory: true
  },
  {
    step: 7,
    title: 'Business Source of Funds',
    component: 'source-of-funds',
    document: 'business_source_of_funds',
    show: false,
    isCompulsory: true
  },
  {
    step: 8,
    title: 'Tax Identification Number (TIN)',
    component: 'tax-identification',
    document: 'tax_identification_number',
    show: false,
    isCompulsory: true
  },
  {
    step: 9,
    title:
      'Anti - Money Laundering / Combating the Financing of Terrorism Policy (AML/CFT/CPF Policy)',
    component: 'anti-money-laundering',
    document: 'anti_money_laundering',
    show: false,
    isCompulsory: false
  },
  {
    step: 10,
    title: 'List of Directors',
    component: 'list-of-directors',
    document: 'list_of_directors',
    show: false,
    isCompulsory: false
  },
  {
    step: 11,
    title: 'Wolfsberg Questionnaire',
    component: 'wolfsberg-questionnaire',
    document: 'completed_wolfsperg_questionnaire',
    show: false,
    isCompulsory: false
  },
  {
    step: 12,
    title: 'Attestation',
    component: 'attestation',
    document: 'attestation',
    show: false,
    isCompulsory: true
  }
]

export const HNI_UPLOAD_INFO = [
  {
    step: 1,
    title: 'Valid ID card',
    component: 'valid-iD',
    document: 'id_card',
    show: false,
    isCompulsory: true
  },
  {
    step: 2,
    title: 'Proof of Business Address',
    component: 'proof-of-address',
    document: 'proof_of_address',
    show: false,
    isCompulsory: true
  },
  {
    step: 3,
    title: 'A passport photograph or selfie image',
    component: 'passport',
    document: 'passport_photograph',
    show: false,
    isCompulsory: true
  },
  {
    step: 4,
    title: 'Attestation Compliance',
    component: 'attestation',
    document: 'attestation',
    show: false,
    isCompulsory: true
  }
]

export const HTTP_ERROR_MESSAGES = {
  400: {
    type: 'error',
    message: 'Invalid request. Please check your input and try again.'
  },
  401: {
    type: 'error',
    message: 'Session Expired.'
  },
  403: {
    type: 'error',
    message: 'Access denied. Contact support for assistance.'
  },
  404: {
    type: 'error',
    message: 'Page not found. Kindly double-check the URL.'
  },
  422: {
    type: 'error',
    message: 'Invalid input. Please review and try again.'
  },
  500: {
    type: 'error',
    message: "Internal server error. We're working to fix it. Please try later."
  },
  502: {
    type: 'error',
    message:
      "Bad gateway. We're experiencing technical difficulties. Please try again later."
  },
  503: {
    type: 'error',
    message:
      "Temporary issue. We'll be back shortly. Thank you for your patience."
  },
  504: {
    type: 'error',
    message: 'Gateway timeout. Retry your request or check your network.'
  },
  429: {
    type: 'error',
    message: 'Too many requests. Please wait and try again.'
  }
}

export const BULK_PAYOUT_PAYMENT_CURRENCIES = ['GHS', 'XAF', 'XOF']

export const SUPPORTED_REQUEST_CURRENCIES = ['USD', 'NGN', 'GBP']
export const TRANSACTION_PROCESSING_MESSAGE =
  'We are currently processing this transaction, you would receive an email when transaction is completed'

export const SIDE_NAV_ITEMS = {
  dashboard: '1',
  exchangeRate: '2',
  paymentLinks: '3',
  cards: '4',
  bridge: '5',
  transactions: '6',
  apiManagementSystem: '7',
  settings: '8',
  fxTransfer: '9',
  payout: '10'
}
export const ALL_CURRENCY = {
  USD: 'USD',
  NGN: 'NGN',
  GBP: 'GBP',
  XOF: 'XOF',
  XAF: 'XAF',
  EUR: 'EUR',
  GHS: 'GHS',
  CFA: 'CFA',
  USDC: 'USDC',
  USDT: 'USDT'
}
export const TRANSACTION_TYPE = {
  DEPOSIT: 'deposit',
  SWAP: 'swap',
  TRANSFER: 'transfer',
  WITHDRAWAL: 'withdrawal',
  LOCAL_TRANSFER: 'local_transfer',
  WIRE_TRANSFER: 'wire_transfer',
  PAYMENT_LINK: 'paymentLink',
  PAY_LINK: 'payLink',
  ASSET_TRANSFER: 'asset_transfer',
  BANK_TRANSFER: 'bank_transfer',
  CURRENCY_SWAP: 'currency_swap',
  FX_TRANSFER: 'fx_transfer',
  MOBILE_MONEY: 'mobile_money',
  PAYOUT: 'payout',
  BULK_PAYOUT: 'bulk_payout',
  RECEIVE_PAYMENT: 'payment_link',
  SWIFT_TRANSFER: 'swift_transfer'
}
export const TENANTS = {
  TORUS: 'torus',
  OVAL: 'oval',
  TMA: 'tma'
}
export const TRANSACTION_ROUTES = [
  'deposit',
  'withdrawal',
  'swap',
  'transfer',
  'currency_swap'
]
export const MOBILE_MONEY_ENABLED_CURRENCIES = ['GHS', 'XOF', 'XAF']
export const TRANSACTION_TYPE_OPTIONS = [
  {
    label: 'Deposit',
    value: 'deposit'
  },
  {
    label: 'Withdrawal',
    value: 'withdrawal'
  },
  {
    label: 'Payment Link',
    value: 'payment_link'
  },
  {
    label: 'Transfer',
    value: 'transfer'
  },
  {
    label: 'Payout',
    value: 'payout'
  },
  {
    label: 'Swap',
    value: 'swap'
  }
]
export const DATE_FILTER_OPTIONS = [
  {
    label: 'All Time',
    value: 'All Time'
  },
  {
    label: '7 Days',
    value: '7 days'
  },
  {
    label: '30 Days',
    value: '30 days'
  },
  {
    label: 'Custom',
    value: 'custom'
  }
]

export const ACCOUNT_DETAILS_TITLES = {
  mno: {
    provider: 'Mobile Money Provider',
    account: 'Phone Number'
  },
  banks: {
    provider: 'Bank',
    account: 'Account Number'
  }
}

export const SUPPORTED_EXTERNAL_API_CURRENCY_OPTIONS = [
  {
    name: 'NGN',
    currency: 'NGN'
  },
  {
    name: 'GBP',
    currency: 'GBP'
  },
  {
    name: 'EURO',
    currency: 'EUR'
  }
]

export const MAX_INACTIVE_TIME = 780000
export const SESSION_EXPIRY_WARNING_TIME = 180000
export const TWENTY_FOUR_HOURS_IN_MILLISECONDS = 86400000
export const ROUTES_TO_EXCLUDE_FROM_SESSION_EXPIRY = [
  'login',
  'signUp',
  'signUpInvite',
  'forgotPassword',
  'recoverPassword',
  'accountSetup',
  'submitKyc',
  'business-information',
  'director-information',
  'upload-document',
  'kyc-completed',
  'adminLogin',
  'verifyUser',
  'verifiedEmail'
]
export const OVAL_DEPOSIT_AGREEMENT = [
  {
    title: 'Account Establishment',
    content: [
      {
        list: 'a. The Account Holder hereby establishes a self-directed custodial account (the "Account") with the Custodian.'
      },
      {
        list: 'b. The Account Holder agrees to deposit funds into the Account in accordance with the provisions of this Agreement.'
      }
    ]
  },
  {
    title: 'Self-Directed Account',
    content: [
      {
        list: "a. The Account Holder acknowledges and understands that the Account is self-directed. The Account Holder shall have the sole authority and responsibility for directing the investment and management of the Account's funds."
      },
      {
        list: 'b. The Account Holder acknowledges that the Custodian does not provide investment advice or recommendations. The Account Holder agrees to seek independent professional advice before making any investment decisions.'
      }
    ]
  },
  {
    title: "Custodian's Duties:",
    content: [
      {
        list: 'a. The Custodian agrees to hold and safeguard the funds deposited into the Account in accordance with applicable laws and regulations.'
      },
      {
        list: 'b. The Custodian shall maintain appropriate records and account statements reflecting the funds deposited and any transactions related to the Account.'
      },
      {
        list: 'c. The Custodian shall provide periodic statements to the Account Holder, detailing the funds held in the Account and any transactions conducted.'
      }
    ]
  },
  {
    title: "Account Holder's Responsibilities:",
    content: [
      {
        list: 'a. The Account Holder shall provide accurate and complete information to the Custodian for the establishment and maintenance of the Account.'
      },
      {
        list: 'b. The Account Holder shall comply with all applicable laws, regulations, and rules governing the Account and the deposited funds.'
      },
      {
        list: 'c. The Account Holder shall be solely responsible for the selection, monitoring, and management of any investments made using the funds in the Account. The Account Holder acknowledges that any investment decisions made are at their own risk.'
      },
      {
        list: "d. The Account Holder shall indemnify and hold the Custodian harmless from any claims, losses, or damages arising from the Account Holder's investment decisions or actions."
      }
    ]
  },
  {
    title: 'Deposit of Funds',
    content: [
      {
        list: "a. The Account Holder shall deposit funds into the Account in accordance with the Custodian's instructions"
      },
      {
        list: 'b. The Custodian shall credit the deposited funds to the Account upon receipt and verification.'
      }
    ]
  },
  {
    title: 'Withdrawal of Funds',
    content: [
      {
        list: "a. The Account Holder may request the withdrawal of funds from the Account in accordance with the Custodian's withdrawal procedures."
      },
      {
        list: 'b. The Custodian shall process the requested withdrawals promptly, subject to any applicable restrictions or requirements.'
      }
    ]
  },
  {
    title: 'Fees and Expenses:',
    content: [
      {
        list: ' a. The Account Holder shall pay the Custodian fees and expenses as agreed upon in a separate fee schedule.'
      },
      {
        list: 'b. The Custodian shall have the right to deduct its fees and expenses directly from the Account.'
      }
    ]
  },
  {
    title: 'Termination:',
    content: [
      {
        list: ' a. Either party may terminate this Agreement upon written notice to the other party.'
      },
      {
        list: ' b. Upon termination, the Custodian shall distribute the funds held in the Account to the Account Holder in accordance with applicable laws and regulations.'
      }
    ]
  },
  {
    title: 'Governing Law and Jurisdiction',
    content: [
      {
        list: 'This Agreement shall be governed by and construed in accordance with the laws of British Columbia. Any disputes arising out of or in connection with this Agreement shall be subject to the exclusive jurisdiction of the courts of British Columbia.'
      }
    ]
  },
  {
    title: 'Entire Agreement',
    content: [
      {
        list: 'This Agreement constitutes the entire understanding and agreement between the parties concerning the Account and deposit relationship and supersedes any prior agreements or understandings, whether written or oral. IN WITNESS WHEREOF, the parties hereto have executed this Self-Directed Effective Date.'
      }
    ]
  }
]
export const TREASURY_INFO = [
  {
    name: 'Eric Arthur',
    position: 'Treasury Manager',
    email: 'eric@ovalfi.com'
  }
]
export const SYMMETRAL_CURRENCIES = [
  ...STABLE_COINS,
  {
    name: 'nigeria',
    symbol: '₦',
    currency: 'NGN',
    currencyFull: 'Nigerian Naira',
    shortCode: 'NG'
  }
]

export const IFT_CURRENCIES = [
  {
    name: 'ghana',
    symbol: '₵',
    currency: 'GHS',
    currencyFull: 'Ghanaian Cedis',
    shortCode: 'GH'
  }
]

export const PROVIDERS_LISTS = [
  {
    label: 'Hub2',
    value: 'hub2',
    currencyPayout: ['XAF, XOF']
  }
]
export const PROVIDERS = {
  HUB2: 'hub2'
}
export const CITIZENSHIP = [
  { label: 'Afghan', value: 'afghan' },
  { label: 'Albanian', value: 'albanian' },
  { label: 'Algerian', value: 'algerian' },
  { label: 'American', value: 'american' },
  { label: 'Andorran', value: 'andorran' },
  { label: 'Angolan', value: 'angolan' },
  { label: 'Antiguan', value: 'antiguan' },
  { label: 'Argentinian', value: 'argentinian' },
  { label: 'Armenian', value: 'armenian' },
  { label: 'Australian', value: 'australian' },
  { label: 'Austrian', value: 'austrian' },
  { label: 'Azerbaijani', value: 'azerbaijani' },
  { label: 'Bahamian', value: 'bahamian' },
  { label: 'Bahraini', value: 'bahraini' },
  { label: 'Bangladeshi', value: 'bangladeshi' },
  { label: 'Barbadian', value: 'barbadian' },
  { label: 'Belarusian', value: 'belarusian' },
  { label: 'Belgian', value: 'belgian' },
  { label: 'Belizean', value: 'belizean' },
  { label: 'Beninese', value: 'beninese' },
  { label: 'Bhutanese', value: 'bhutanese' },
  { label: 'Bolivian', value: 'bolivian' },
  { label: 'Bosnian', value: 'bosnian' },
  { label: 'Botswanan', value: 'botswanan' },
  { label: 'Brazilian', value: 'brazilian' },
  { label: 'British', value: 'british' },
  { label: 'Bruneian', value: 'bruneian' },
  { label: 'Bulgarian', value: 'bulgarian' },
  { label: 'Burkinabé', value: 'burkinabe' },
  { label: 'Burmese', value: 'burmese' },
  { label: 'Burundian', value: 'burundian' },
  { label: 'Cabo Verdean', value: 'cabo_verdean' },
  { label: 'Cambodian', value: 'cambodian' },
  { label: 'Cameroonian', value: 'cameroonian' },
  { label: 'Canadian', value: 'canadian' },
  { label: 'Central African', value: 'central_african' },
  { label: 'Chadian', value: 'chadian' },
  { label: 'Chilean', value: 'chilean' },
  { label: 'Chinese', value: 'chinese' },
  { label: 'Colombian', value: 'colombian' },
  { label: 'Comoran', value: 'comoran' },
  { label: 'Congolese', value: 'congolese' },
  { label: 'Costa Rican', value: 'costa_rican' },
  { label: 'Croatian', value: 'croatian' },
  { label: 'Cuban', value: 'cuban' },
  { label: 'Cypriot', value: 'cypriot' },
  { label: 'Czech', value: 'czech' },
  { label: 'Danish', value: 'danish' },
  { label: 'Djiboutian', value: 'djiboutian' },
  { label: 'Dominican', value: 'dominican' },
  { label: 'Dutch', value: 'dutch' },
  { label: 'East Timorese', value: 'east_timorese' },
  { label: 'Ecuadorean', value: 'ecuadorean' },
  { label: 'Egyptian', value: 'egyptian' },
  { label: 'Emirati', value: 'emirati' },
  { label: 'Equatorial Guinean', value: 'equatorial_guinean' },
  { label: 'Eritrean', value: 'eritrean' },
  { label: 'Estonian', value: 'estonian' },
  { label: 'Ethiopian', value: 'ethiopian' },
  { label: 'Fijian', value: 'fijian' },
  { label: 'Finnish', value: 'finnish' },
  { label: 'French', value: 'french' },
  { label: 'Gabonese', value: 'gabonese' },
  { label: 'Gambian', value: 'gambian' },
  { label: 'Georgian', value: 'georgian' },
  { label: 'German', value: 'german' },
  { label: 'Ghanaian', value: 'ghanaian' },
  { label: 'Greek', value: 'greek' },
  { label: 'Grenadian', value: 'grenadian' },
  { label: 'Guatemalan', value: 'guatemalan' },
  { label: 'Guinean', value: 'guinean' },
  { label: 'Guyanese', value: 'guyanese' },
  { label: 'Haitian', value: 'haitian' },
  { label: 'Honduran', value: 'honduran' },
  { label: 'Hungarian', value: 'hungarian' },
  { label: 'Icelander', value: 'icelander' },
  { label: 'Indian', value: 'indian' },
  { label: 'Indonesian', value: 'indonesian' },
  { label: 'Iranian', value: 'iranian' },
  { label: 'Iraqi', value: 'iraqi' },
  { label: 'Irish', value: 'irish' },
  { label: 'Israeli', value: 'israeli' },
  { label: 'Italian', value: 'italian' },
  { label: 'Ivorian', value: 'ivorian' },
  { label: 'Jamaican', value: 'jamaican' },
  { label: 'Japanese', value: 'japanese' },
  { label: 'Jordanian', value: 'jordanian' },
  { label: 'Kazakhstani', value: 'kazakhstani' },
  { label: 'Kenyan', value: 'kenyan' },
  { label: 'Kiribati', value: 'kiribati' },
  { label: 'Kuwaiti', value: 'kuwaiti' },
  { label: 'Kyrgyzstani', value: 'kyrgyzstani' },
  { label: 'Lao', value: 'lao' },
  { label: 'Latvian', value: 'latvian' },
  { label: 'Lebanese', value: 'lebanese' },
  { label: 'Lesotho', value: 'lesotho' },
  { label: 'Liberian', value: 'liberian' },
  { label: 'Libyan', value: 'libyan' },
  { label: 'Liechtensteiner', value: 'liechtensteiner' },
  { label: 'Lithuanian', value: 'lithuanian' },
  { label: 'Luxembourgish', value: 'luxembourgish' },
  { label: 'Macedonian', value: 'macedonian' },
  { label: 'Malagasy', value: 'malagasy' },
  { label: 'Malawian', value: 'malawian' },
  { label: 'Malaysian', value: 'malaysian' },
  { label: 'Maldivian', value: 'maldivian' },
  { label: 'Malian', value: 'malian' },
  { label: 'Maltese', value: 'maltese' },
  { label: 'Marshallese', value: 'marshallese' },
  { label: 'Mauritanian', value: 'mauritanian' },
  { label: 'Mauritian', value: 'mauritian' },
  { label: 'Mexican', value: 'mexican' },
  { label: 'Micronesian', value: 'micronesian' },
  { label: 'Moldovan', value: 'moldovan' },
  { label: 'Monacan', value: 'monacan' },
  { label: 'Mongolian', value: 'mongolian' },
  { label: 'Montenegrin', value: 'montenegrin' },
  { label: 'Moroccan', value: 'moroccan' },
  { label: 'Mozambican', value: 'mozambican' },
  { label: 'Namibian', value: 'namibian' },
  { label: 'Nauruan', value: 'nauruan' },
  { label: 'Nepalese', value: 'nepalese' },
  { label: 'New Zealander', value: 'new_zealander' },
  { label: 'Nicaraguan', value: 'nicaraguan' },
  { label: 'Nigerian', value: 'nigerian' },
  { label: 'Norwegian', value: 'norwegian' },
  { label: 'Omani', value: 'omani' },
  { label: 'Pakistani', value: 'pakistani' },
  { label: 'Palauan', value: 'palauan' },
  { label: 'Panamanian', value: 'panamanian' },
  { label: 'Papua New Guinean', value: 'papua_new_guinean' },
  { label: 'Paraguayan', value: 'paraguayan' },
  { label: 'Peruvian', value: 'peruvian' },
  { label: 'Philippine', value: 'philippine' },
  { label: 'Polish', value: 'polish' },
  { label: 'Portuguese', value: 'portuguese' },
  { label: 'Qatari', value: 'qatari' },
  { label: 'Romanian', value: 'romanian' },
  { label: 'Russian', value: 'russian' },
  { label: 'Rwandan', value: 'rwandan' },
  { label: 'Saint Lucian', value: 'saint_lucian' },
  { label: 'Salvadoran', value: 'salvadoran' },
  { label: 'Samoan', value: 'samoan' },
  { label: 'San Marinese', value: 'san_marinese' },
  { label: 'Sao Tomean', value: 'sao_tomean' },
  { label: 'Saudi', value: 'saudi' },
  { label: 'Senegalese', value: 'senegalese' },
  { label: 'Serbian', value: 'serbian' },
  { label: 'Seychellois', value: 'seychellois' },
  { label: 'Sierra Leonean', value: 'sierra_leonean' },
  { label: 'Singaporean', value: 'singaporean' },
  { label: 'Slovak', value: 'slovak' },
  { label: 'Slovenian', value: 'slovenian' },
  { label: 'Solomon Islander', value: 'solomon_islander' },
  { label: 'Somali', value: 'somali' },
  { label: 'South African', value: 'south_african' },
  { label: 'South Korean', value: 'south_korean' },
  { label: 'Spanish', value: 'spanish' },
  { label: 'Sri Lankan', value: 'sri_lankan' },
  { label: 'Sudanese', value: 'sudanese' },
  { label: 'Surinamese', value: 'surinamese' },
  { label: 'Swazi', value: 'swazi' },
  { label: 'Swedish', value: 'swedish' },
  { label: 'Swiss', value: 'swiss' },
  { label: 'Syrian', value: 'syrian' },
  { label: 'Taiwanese', value: 'taiwanese' },
  { label: 'Tajikistani', value: 'tajikistani' },
  { label: 'Tanzanian', value: 'tanzanian' },
  { label: 'Thai', value: 'thai' },
  { label: 'Togolese', value: 'togolese' },
  { label: 'Tongan', value: 'tongan' },
  { label: 'Trinidadian', value: 'trinidadian' },
  { label: 'Tunisian', value: 'tunisian' },
  { label: 'Turkish', value: 'turkish' },
  { label: 'Turkmen', value: 'turkmen' },
  { label: 'Tuvaluan', value: 'tuvaluan' },
  { label: 'Ugandan', value: 'ugandan' },
  { label: 'Ukrainian', value: 'ukrainian' },
  { label: 'Uruguayan', value: 'uruguayan' },
  { label: 'Uzbekistani', value: 'uzbekistani' },
  { label: 'Vanuatuan', value: 'vanuatuan' },
  { label: 'Venezuelan', value: 'venezuelan' },
  { label: 'Vietnamese', value: 'vietnamese' },
  { label: 'Yemeni', value: 'yemeni' },
  { label: 'Zambian', value: 'zambian' },
  { label: 'Zimbabwean', value: 'zimbabwean' }
]

export const MonthlyTransaction = [
  { value: '1 - 10', label: '1 - 10' },
  { value: '10 - 20', label: '10 - 20' },
  { value: '20 - 30', label: '20 - 30' },
  { value: '30 - 40', label: '30 - 40' },
  { value: '40 - 50', label: '40 - 50' },
  { value: '50 - 60', label: '50 - 60' },
  { value: '60 - 70', label: '60 - 70' },
  { value: '70 - 80', label: '70 - 80' },
  { value: '80 - 90', label: '80 - 90' },
  { value: '90 - 100', label: '90 - 100' },
  { value: '500+', label: '500+' }
]
export const LOCAL_CURRENCIES = ['NGN', 'GHS', 'XAF', 'XOF']
export const FX_CURRENCIES = ['USD', 'EUR', 'GBP']
